import { useMemo } from 'react';
import HomeRecentSearches from '@pages/Home/sections/HomeRecentSearches/HomeRecentSearches';
import HomeReportsAndNews from '@pages/Home/sections/HomeReportsAndNews/HomeReportsAndNews';
import HomeCategoryLens from '@pages/Home/sections/HomeCategoryLens/HomeCategoryLens';
import HomeTerritoryOptions from '@pages/Home/sections/HomeTerritoryOptions/HomeTerritoryOptions';
import HomeLandscape from '@pages/Home/sections/HomeLandscape/HomeLandscape';
import HomeSalesFocusChains from '@pages/Home/sections/HomeSalesFocusChains/HomeSalesFocusChains';
import HomeWorkspaceLayout from '@pages/Home/components/HomeWorkspaceLayout';
import { TerritorySelectionProvider } from '@pages/Home/context/TerritorySelectionContext';
import { TerritoryOptionsProvider } from '@pages/Home/context/TerritoryOptionsContext';
import { LandscapeViewProvider } from '@pages/Home/context/LandscapeViewContext';
import { HomeWidgets } from '@pages/Home/constants';

export const HOME_SALES_SCROLLBAR_ID = 'HomeSalesScrollbar';
const SALES_VISIBLE_WIDGETS: HomeWidgets[] = [HomeWidgets.ReportsAiSummary, HomeWidgets.RelatedCharts];

const SalesWorkspace = () => {
    const sections = useMemo(
        () => [
            {
                id: 'news-reports',
                title: 'News & Reports',
                testId: 'blockHomeSalesReports',
                Component: HomeReportsAndNews,
            },
            {
                id: 'territory-options',
                title: 'My Territory',
                testId: 'blockHomeSalesTerritoryOptions',
                Component: () => <HomeTerritoryOptions showInNav={false} />,
            },
            {
                id: 'landscape',
                title: 'Landscape',
                testId: 'blockHomeSalesLandscape',
                Component: HomeLandscape,
            },
            {
                id: 'sales-focus-chains',
                title: 'Operators Focus',
                testId: 'blockHomeSalesFocusChains',
                Component: HomeSalesFocusChains,
            },
            {
                id: 'category-lens',
                title: 'Category Lens',
                testId: 'blockHomeSalesCategoryLens',
                Component: () => (
                    <HomeCategoryLens
                        nextSectionId="recent-searches"
                        visibleWidgets={SALES_VISIBLE_WIDGETS}
                        compact
                    />
                ),
            },
            {
                id: 'recent-searches',
                title: 'Recent Searches',
                testId: 'blockHomeSalesRecentSearches',
                Component: HomeRecentSearches,
            },
        ],
        []
    );

    return (
        <TerritoryOptionsProvider>
            <TerritorySelectionProvider>
                <LandscapeViewProvider>
                    <HomeWorkspaceLayout
                        scrollbarId={HOME_SALES_SCROLLBAR_ID}
                        sections={sections}
                    />
                </LandscapeViewProvider>
            </TerritorySelectionProvider>
        </TerritoryOptionsProvider>
    );
};

export default SalesWorkspace;
